var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('v-main',[(_vm.getKioskId !== undefined)?_c('appHeader'):_vm._e(),_c('v-fade-transition',{attrs:{"leave-absolute":""}},[_c('router-view')],1)],1),_c('pdfViewer'),_c('image-viewer'),_c('email-viewer'),_c('options-viewer'),_c('court-timing-viewer'),_c('session-end-viewer'),_c('ThinkingViewer'),_c('recognition')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }